import React, { useState, useEffect, useImperativeHandle } from 'react';
import { Icon, Collapse } from '@whalecloud/fdx';
import { i18n } from 'fishx';

import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

import { ActTypeObj } from '@/utils';
import { getDefaultTree, checkGroupLowLimit } from '../utils';

import AddOfferGroup from '../AddOfferGroup';

import styles from '../index.module.less';

const IndividualPlan = props => {
  const { modelKey, offerGroupArr = [], refInstance } = props;
  const [sourceTree, setSourceTree] = useState([]);

  useEffect(() => {
    if (!isEmpty(offerGroupArr)) {
      const defaultTree = getDefaultTree(offerGroupArr);
      setSourceTree(defaultTree);
    }
  }, [offerGroupArr]);

  useImperativeHandle(refInstance, () => ({
    getIndividualPlanInfo: async() => {
      await checkGroupLowLimit(sourceTree, 'INDIVIDUAL_PLAN_LOWER');
      let result = [];
      sourceTree.forEach(it => {
        if (!isEmpty(it.children)) {
          let res = [];
          if (modelKey === 'newConnection') {
            res = it.children.map(child => ({
              offerId: child.offerId,
              offerName: child.offerName,
              actType: ActTypeObj.ADD,
            }));
          } else {
            res = it.children.map(child => ({
              offerId: child.offerId,
              operationType: ActTypeObj.ADD,
            }));
          }
          result = [...result, ...res];
        }
      });
      return result;
    },
  }));

  const handleAdd = selectedInfo => setSourceTree(selectedInfo);

  const handleDelete = (e, fatherIndex, childIndex) => {
    e.stopPropagation();
    const cloneArr = cloneDeep(sourceTree);
    const curOfferGroup = cloneArr[fatherIndex];
    const children = (curOfferGroup.children || []).filter((it, i) => i !== childIndex);
    cloneArr[fatherIndex] = {
      ...curOfferGroup,
      children,
    };
    setSourceTree([...cloneArr]);
  };

  const renderExpandIcon = res => {
    const { isActive } = res;
    return (
      <Icon type={isActive ? 'caret-down' : 'caret-up'} />
    );
  };

  const renderDeleteEventBtn = (fatherIndex, childIndex, child) => {
    if (child.isNecessary) {
      return '';
    }
    return (
      <div className={styles.btnsBox} onClick={e => handleDelete(e, fatherIndex, childIndex)}>
        <Icon type="delete" />
      </div>
    );
  };

  return (
    <div className={`blockWrap ${styles.offerGroupDiv}`}>
      <div className={styles.header}>
        <h3 className="blockTitle">{i18n('SELECT_INDIVIDUAL_PLAN')}</h3>
        <AddOfferGroup offerGroupArr={offerGroupArr} onSubmit={handleAdd} selectedTree={sourceTree} title={i18n('SELECT_INDIVIDUAL_PLAN')} />
      </div>
      {
        (sourceTree || []).map((it, fatherIndex) => {
          if (!isEmpty(it.children)) {
            return (
              <div key={`${it.offerGroupCode}_${fatherIndex}`} className={styles.offerInfo}>
                <h4 className="blockSubTitle">{`${it.offerGroupName} [${it.lowLimit || 0} - ${it.upperLimit || 'N'}]`}</h4>
                <Collapse renderExpandIcon={renderExpandIcon}>
                  {
                    (it.children || []).map((child, childIndex) => (
                      <Collapse.Panel
                        header={get(child, 'offerDto.offerName')}
                        key={`${child.offerId}_${childIndex}`}
                        extra={renderDeleteEventBtn(fatherIndex, childIndex, child)}
                      />
                    ))
                  }
                </Collapse>
              </div>
            );
          }
          return '';
        })
      }
    </div>
  );
};

export default React.forwardRef((props, ref) => <IndividualPlan {...props} refInstance={ref} />);
